import {init} from '@craftcms/graphiql';
document.addEventListener('DOMContentLoaded', function () {
  init(document.getElementById('graphiql'));
});
